import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiArrowRight,FiPlay,FiCloud,FiCode,FiZap,FiShield,FiTrendingUp,FiDatabase,FiCpu}=FiIcons;

const Hero=()=> {
return (
<section className="pt-32 pb-20 px-6 overflow-hidden relative">
{/* Animated Beams Background */}
<div className="absolute inset-0 overflow-hidden">
{/* Beam 1 */}
<motion.div initial={{opacity: 0,scale: 0}} animate={{opacity: [0,0.3,0.3,0],scale: [0,1.5,2,2.5],rotate: [0,45,90,135]}} transition={{duration: 8,repeat: Infinity,ease: "easeInOut",repeatType: "loop"}} className="absolute top-20 left-10 w-96 h-2 bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent" />
{/* Beam 2 */}
<motion.div initial={{opacity: 0,scale: 0}} animate={{opacity: [0,0.25,0.25,0],scale: [0,1.2,1.8,2.2],rotate: [0,-30,-60,-90]}} transition={{duration: 10,repeat: Infinity,ease: "easeInOut",repeatType: "loop",delay: 2}} className="absolute top-40 right-20 w-80 h-1 bg-gradient-to-r from-transparent via-purple-500/20 to-transparent" />
{/* Beam 3 */}
<motion.div initial={{opacity: 0,scale: 0}} animate={{opacity: [0,0.2,0.2,0],scale: [0,1,1.5,2],rotate: [0,60,120,180]}} transition={{duration: 12,repeat: Infinity,ease: "easeInOut",repeatType: "loop",delay: 4}} className="absolute bottom-20 left-1/3 w-72 h-1.5 bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent" />
{/* Beam 4 */}
<motion.div initial={{opacity: 0,scale: 0}} animate={{opacity: [0,0.15,0.15,0],scale: [0,0.8,1.2,1.6],rotate: [0,-45,-90,-135]}} transition={{duration: 15,repeat: Infinity,ease: "easeInOut",repeatType: "loop",delay: 6}} className="absolute top-1/4 right-1/4 w-64 h-1 bg-gradient-to-r from-transparent via-pink-500/20 to-transparent" />
{/* Beam 5 */}
<motion.div initial={{opacity: 0,scale: 0}} animate={{opacity: [0,0.18,0.18,0],scale: [0,1.1,1.6,2.1],rotate: [0,30,60,90]}} transition={{duration: 14,repeat: Infinity,ease: "easeInOut",repeatType: "loop",delay: 8}} className="absolute bottom-40 right-10 w-88 h-2 bg-gradient-to-r from-transparent via-emerald-500/20 to-transparent" />
{/* Additional subtle beams */}
<motion.div animate={{opacity: [0.1,0.05,0.1],x: [-100,100,-100]}} transition={{duration: 20,repeat: Infinity,ease: "easeInOut"}} className="absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-indigo-500/10 to-transparent" />
<motion.div animate={{opacity: [0.08,0.03,0.08],y: [-50,50,-50]}} transition={{duration: 18,repeat: Infinity,ease: "easeInOut",delay: 10}} className="absolute top-0 left-1/2 w-0.5 h-full bg-gradient-to-b from-transparent via-purple-500/10 to-transparent" />
</div>
<div className="max-w-7xl mx-auto relative z-10">
<div className="grid lg:grid-cols-2 gap-12 items-center">
{/* Content */}
<motion.div initial={{opacity: 0,x: -50}} animate={{opacity: 1,x: 0}} transition={{duration: 0.8,delay: 0.2}} className="z-20 relative" >
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: 0.4}} className="inline-flex items-center bg-white/10 backdrop-blur-lg rounded-full px-4 py-2 mb-6" >
<SafeIcon icon={FiZap} className="text-yellow-400 mr-2" />
<span style={{color: 'rgb(255,255,255)',fontSize: '15px'}} className="text-white text-sm font-medium">Digital Transformation Studio</span>
</motion.div>
<motion.h1 initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.6}} className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight" >
Transform Your <span className="bg-gradient-to-r from-indigo-400 to-purple-400 bg-clip-text text-transparent">{" "}Business</span>
<br />
Into a Digital <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">{" "}Powerhouse</span>
</motion.h1>
<motion.p initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 0.8}} className="text-xl text-gray-300 mb-8 leading-relaxed" >
We seamlessly integrate Cloud-Native solutions with AI-powered Services and Open-Source Technologies with your core business processes to digitize and transform your entire organization into a dynamic,future-ready enterprise.
</motion.p>
<motion.div initial={{opacity: 0,y: 20}} animate={{opacity: 1,y: 0}} transition={{duration: 0.8,delay: 1}} className="flex flex-col sm:flex-row gap-4" >
<motion.button whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} className="bg-gradient-to-r from-indigo-500 to-purple-600 text-white px-8 py-4 rounded-full font-semibold hover:shadow-xl transition-all duration-300 flex items-center justify-center space-x-2" >
<span>Start Your Transformation</span>
<SafeIcon icon={FiArrowRight} className="text-lg" />
</motion.button>
<motion.button whileHover={{scale: 1.05}} whileTap={{scale: 0.95}} className="border-2 border-white/30 text-white px-8 py-4 rounded-full font-semibold hover:bg-white/10 transition-all duration-300 flex items-center justify-center space-x-2" >
<SafeIcon icon={FiPlay} className="text-lg" />
<span>Watch Demo</span>
</motion.button>
</motion.div>
</motion.div>
{/* Visual Elements */}
<motion.div initial={{opacity: 0,x: 50}} animate={{opacity: 1,x: 0}} transition={{duration: 0.8,delay: 0.4}} className="relative h-[500px] w-full hidden lg:block" >
<div className="relative w-full h-full z-10">
{/* 1. Cloud-Native (Top Right) */}
<motion.div animate={{y: [-15,15,-15]}} transition={{duration: 5,repeat: Infinity,ease: "easeInOut"}} className="absolute top-0 right-0 bg-gradient-to-r from-indigo-500/20 to-purple-500/20 backdrop-blur-lg rounded-2xl p-4 lg:p-6 border border-white/10 shadow-xl" >
<SafeIcon icon={FiCloud} className="text-2xl lg:text-3xl text-indigo-400 mb-2" />
<h3 className="text-white font-semibold text-sm lg:text-base">Cloud-Native</h3>
<p className="text-gray-300 text-xs lg:text-sm">Scalable Solutions</p>
</motion.div>
{/* 2. Open Source (Bottom Left) */}
<motion.div animate={{y: [15,-15,15]}} transition={{duration: 6,repeat: Infinity,ease: "easeInOut",delay: 1}} className="absolute bottom-10 left-0 bg-gradient-to-r from-purple-500/20 to-pink-500/20 backdrop-blur-lg rounded-2xl p-4 lg:p-6 border border-white/10 shadow-xl" >
<SafeIcon icon={FiCode} className="text-2xl lg:text-3xl text-purple-400 mb-2" />
<h3 className="text-white font-semibold text-sm lg:text-base">Open Source</h3>
<p className="text-gray-300 text-xs lg:text-sm">Flexible Tech</p>
</motion.div>
{/* 3. Security (Top Left) */}
<motion.div animate={{y: [-10,10,-10]}} transition={{duration: 7,repeat: Infinity,ease: "easeInOut",delay: 0.5}} className="absolute top-10 left-10 bg-gradient-to-r from-green-500/20 to-emerald-500/20 backdrop-blur-lg rounded-2xl p-4 border border-white/10 shadow-xl" >
<div className="flex items-center space-x-3">
<div className="p-2 bg-green-500/20 rounded-lg">
<SafeIcon icon={FiShield} className="text-xl text-green-400" />
</div>
<div>
<h3 className="text-white font-semibold text-sm">Security</h3>
<p className="text-gray-300 text-xs">Enterprise Grade</p>
</div>
</div>
</motion.div>
{/* 4. Analytics (Bottom Right) */}
<motion.div animate={{y: [10,-10,10]}} transition={{duration: 5.5,repeat: Infinity,ease: "easeInOut",delay: 1.5}} className="absolute bottom-20 right-10 bg-gradient-to-r from-orange-500/20 to-red-500/20 backdrop-blur-lg rounded-2xl p-4 border border-white/10 shadow-xl" >
<div className="flex items-center space-x-3">
<div className="p-2 bg-orange-500/20 rounded-lg">
<SafeIcon icon={FiTrendingUp} className="text-xl text-orange-400" />
</div>
<div>
<h3 className="text-white font-semibold text-sm">Growth</h3>
<p className="text-gray-300 text-xs">Data Driven</p>
</div>
</div>
</motion.div>
{/* 5. Database (Middle Left) - Moved higher */}
<motion.div animate={{x: [-10,10,-10]}} transition={{duration: 8,repeat: Infinity,ease: "easeInOut",delay: 2}} className="absolute top-1/3 left-0 transform -translate-y-1/2 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 backdrop-blur-lg rounded-2xl p-4 border border-white/10 shadow-xl" >
<SafeIcon icon={FiDatabase} className="text-2xl text-blue-400 mb-1" />
<h3 className="text-white text-xs font-medium">Automation</h3>
<p className="text-gray-300 text-xs">Data Driven</p>
</motion.div>
{/* 6. Automation (Middle Right) */}
<motion.div animate={{x: [10,-10,10]}} transition={{duration: 6.5,repeat: Infinity,ease: "easeInOut",delay: 2.5}} className="absolute top-1/3 right-20 bg-gradient-to-r from-pink-500/20 to-rose-500/20 backdrop-blur-lg rounded-2xl p-4 border border-white/10 shadow-xl" >
<SafeIcon icon={FiCpu} className="text-2xl text-pink-400 mb-1" />
<h3 className="text-white text-xs font-medium">AI Agents</h3>
<p className="text-gray-300 text-xs">Data Driven</p>
</motion.div>
{/* Central Glow */}
<div className="w-64 h-64 lg:w-96 lg:h-96 bg-gradient-to-r from-indigo-500/30 to-purple-500/30 rounded-full blur-3xl absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 -z-10"></div>
</div>
</motion.div>
</div>
</div>
</section>
);
};

export default Hero;